export const KNOWLEDGE_BASE_URL = {
  CUSTOM_STYLING: 'https://knowledge-base.yieldbird.com/rich-placements/multianchor',
} as const
